// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file inventory/generate_custom_barcode.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ItemType } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GenerateCustomBarcodeRequest
 */
export class GenerateCustomBarcodeRequest extends Message<GenerateCustomBarcodeRequest> {
  /**
   * The ID of the inventory item for which to generate a custom barcode.
   *
   * @generated from field: string master_id = 1;
   */
  masterId = "";

  /**
   * The custom barcode to be generated for the inventory item.
   *
   * @generated from field: string custom_barcode = 2;
   */
  customBarcode = "";

  /**
   * The type of the inventory item (e.g., MEDICAL, NON_MEDICAL).
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 3;
   */
  itemType = ItemType.UNSPECIFIED;

  constructor(data?: PartialMessage<GenerateCustomBarcodeRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GenerateCustomBarcodeRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "custom_barcode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenerateCustomBarcodeRequest {
    return new GenerateCustomBarcodeRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenerateCustomBarcodeRequest {
    return new GenerateCustomBarcodeRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenerateCustomBarcodeRequest {
    return new GenerateCustomBarcodeRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GenerateCustomBarcodeRequest | PlainMessage<GenerateCustomBarcodeRequest> | undefined, b: GenerateCustomBarcodeRequest | PlainMessage<GenerateCustomBarcodeRequest> | undefined): boolean {
    return proto3.util.equals(GenerateCustomBarcodeRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GenerateCustomBarcodeResponse
 */
export class GenerateCustomBarcodeResponse extends Message<GenerateCustomBarcodeResponse> {
  /**
   * The generated custom barcode for the inventory item.
   *
   * @generated from field: string barcode = 1;
   */
  barcode = "";

  constructor(data?: PartialMessage<GenerateCustomBarcodeResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GenerateCustomBarcodeResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "barcode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GenerateCustomBarcodeResponse {
    return new GenerateCustomBarcodeResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GenerateCustomBarcodeResponse {
    return new GenerateCustomBarcodeResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GenerateCustomBarcodeResponse {
    return new GenerateCustomBarcodeResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GenerateCustomBarcodeResponse | PlainMessage<GenerateCustomBarcodeResponse> | undefined, b: GenerateCustomBarcodeResponse | PlainMessage<GenerateCustomBarcodeResponse> | undefined): boolean {
    return proto3.util.equals(GenerateCustomBarcodeResponse, a, b);
  }
}

